import { useCallback, useState } from 'react'
import {
    RiZoomInLine,
    RiZoomOutLine,
    RiFullscreenLine,
} from 'react-icons/ri'
import { useEditorStore } from '@/stores/useEditorStore'
import { useProjectStore } from '@/stores/useProjectStore'
import { getCanvasInstance } from '@/lib/canvasInstance'
import styles from './ZoomControls.module.css'

const ZOOM_PRESETS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3]
const MM_TO_PX = 3.7795

export function ZoomControls() {
    const { zoom, setZoom } = useEditorStore()
    const { widthMm, heightMm } = useProjectStore()
    const [showMenu, setShowMenu] = useState(false)

    const handleFitToScreen = useCallback(() => {
        const canvas = getCanvasInstance()
        if (!canvas) return
        const dw = Math.round(widthMm * MM_TO_PX)
        const dh = Math.round(heightMm * MM_TO_PX)
        const cw = canvas.getWidth()
        const ch = canvas.getHeight()
        const fitZoom = Math.min((cw - 80) / dw, (ch - 80) / dh, 1)
        const offsetX = (cw - dw * fitZoom) / 2
        const offsetY = (ch - dh * fitZoom) / 2
        canvas.setViewportTransform([fitZoom, 0, 0, fitZoom, offsetX, offsetY])
        setZoom(fitZoom)
        canvas.requestRenderAll()
    }, [widthMm, heightMm, setZoom])

    const handlePreset = useCallback((value: number) => {
        setZoom(value)
        setShowMenu(false)
    }, [setZoom])

    return (
        <div className={styles.controls}>
            <button
                className={styles.btn}
                onClick={() => setZoom(zoom - 0.1)}
                title="Alejar"
            >
                <RiZoomOutLine />
            </button>

            <div className={styles.zoomWrapper}>
                <button
                    className={styles.zoomBtn}
                    onClick={() => setShowMenu(!showMenu)}
                >
                    {Math.round(zoom * 100)}%
                </button>
                {showMenu && (
                    <>
                        <div className={styles.overlay} onClick={() => setShowMenu(false)} />
                        <div className={styles.menu}>
                            {ZOOM_PRESETS.map(p => (
                                <button
                                    key={p}
                                    className={`${styles.menuItem} ${Math.abs(zoom - p) < 0.01 ? styles.menuActive : ''}`}
                                    onClick={() => handlePreset(p)}
                                >
                                    {Math.round(p * 100)}%
                                </button>
                            ))}
                        </div>
                    </>
                )}
            </div>

            <button
                className={styles.btn}
                onClick={() => setZoom(zoom + 0.1)}
                title="Acercar"
            >
                <RiZoomInLine />
            </button>

            <div className={styles.separator} />

            <button
                className={styles.btn}
                onClick={handleFitToScreen}
                title="Ajustar a pantalla"
            >
                <RiFullscreenLine />
            </button>
        </div>
    )
}
